import React, { useCallback } from 'react'
import { useMutation, useQuery } from '@apollo/client'
import { useParams } from 'react-router-dom'
import { useHistory } from 'hooks/useHistory'
import { GET_ONE_QUESTION_PASSAGE, UPDATE_QUESTION_PASSAGE } from 'queries/questionPassage'
import { updateCARSQuestion, updateCARSQuestionVariables } from '__generatedTypes__/updateCARSQuestion'
import { CreateQuestionPassageInput } from '__generatedTypes__/globalTypes'
import { findOneQuestionPassage, findOneQuestionPassageVariables } from '__generatedTypes__/findOneQuestionPassage'
import { cmsRoutes, useLink } from 'routes/cmsRoutes'
import { QUERY_PARAM, QUESTION_TEMPLATES_TAB } from 'pagesNew/Questions/QuestionTabs'
import { PageLoader } from 'components/PageLoader'
import { toast } from 'utils/toast'
import { Form } from '../Form'

export const TemplateEdit = () => {
  const { templateId = '' } = useParams()
  const { loadingHistory, populateHistoryWithUser } = useHistory()
  const { navigate } = useLink()

  const [update] = useMutation<updateCARSQuestion, updateCARSQuestionVariables>(UPDATE_QUESTION_PASSAGE)

  const { data, loading } = useQuery<findOneQuestionPassage, findOneQuestionPassageVariables>(
    GET_ONE_QUESTION_PASSAGE,
    {
      variables: {
        params: templateId,
      },
      fetchPolicy: 'network-only',
    }
  )
  const questionPassageTemplate = data?.findOneQuestionPassage

  const handleSubmit = useCallback(
    async (question: CreateQuestionPassageInput) => {
      try {
        await update({
          variables: {
            params: {
              passage: {
                id: templateId,
                isTemplate: question.isTemplate ?? false,
                templateName: question.templateName,
                content: question.content,
                subject: question.subject,
                level: question.level,
                title: question.title,
                history: populateHistoryWithUser(question.history),
              },
              questions: question.questions || [],
            },
          },
        })

        navigate(
          cmsRoutes.CARS_QUESTION_LIST,
          {},
          {
            searchParams: new URLSearchParams({
              [QUERY_PARAM]: QUESTION_TEMPLATES_TAB.id,
            }),
          }
        )

        toast.success('Question template updated successfully')
      } catch (error) {
        toast.error('Failed to update question template')
      }
    },
    [populateHistoryWithUser, update]
  )

  if (loading || loadingHistory) {
    return <PageLoader />
  }

  if (!questionPassageTemplate) {
    return (
      <div style={{ padding: 20 }}>
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
          <h1>Question template not found</h1>
        </div>
      </div>
    )
  }

  return (
    <div>
      <Form isTemplate passageQuestion={questionPassageTemplate} onSubmit={handleSubmit} />
    </div>
  )
}
